export default __webpack_public_path__ + "static/media/segre13.47679090.jpg";